import axios, { AxiosInstance } from 'axios';
import { stringify } from 'qs';
import { v4 as uuidv4 } from 'uuid';
import { getToken } from './TokenLocator';

export const getServiceAxiosWithCorrelationId = (
  correlationId: string
): AxiosInstance => {
  const userServiceAxios = axios.create({
    paramsSerializer: (params) => stringify(params, { arrayFormat: 'repeat' }),
  });

  const token = getToken();
  if (token) {
    userServiceAxios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token.access_token}`;
  }
  userServiceAxios.defaults.headers.common['x-correlation-id'] = correlationId;

  return userServiceAxios;
};

export const getServiceAxios = (): AxiosInstance => {
  const correlationId = uuidv4();
  return getServiceAxiosWithCorrelationId(correlationId);
};
